import axios from 'axios'
import './common'

export default {
    getConnections: (params) => axios.get(`/connections`, { params: params }),
    getAccounts: () => axios.get(`/accounts`),
}